
<!--<script src="js/jquery-1.11.0.min.js"></script>-->
<!--<script src="js/bootstrap.min.js"></script>-->
<!--<script src="js/plugins.js"></script>-->
<!--<script src="js/script.js"></script>-->
<script>
// import './js/jquery-1.11.0.min.js';
// import './js/bootstrap.min.js';
// // import './js/plugins.js';
// import './js/script.js';

export default {
  name: "home",
  create() {


  },
  data(){
    return{

    }
  },
  created() {
    // this.getList()
    // this.getMes1()
    // this.getMes2()

  },
  mounted() {
    const meta1 = document.createElement('meta');
    meta1.setAttribute('charset', 'utf-8');
    document.head.appendChild(meta1);

    const meta2 = document.createElement('meta');
    meta2.setAttribute('http-equiv', 'X-UA-Compatible');
    meta2.setAttribute('content', 'IE=edge');
    document.head.appendChild(meta2);

    const meta3 = document.createElement('meta');
    meta3.setAttribute('name', 'viewport');
    meta3.setAttribute('content', 'width=device-width, initial-scale=1.0');
    document.head.appendChild(meta3);

    const meta4 = document.createElement('meta');
    meta4.setAttribute('name', 'format-detection');
    meta4.setAttribute('content', 'telephone=no');
    document.head.appendChild(meta4);

    const meta5 = document.createElement('meta');
    meta5.setAttribute('name', 'apple-mobile-web-app-capable');
    meta5.setAttribute('content', 'yes');
    document.head.appendChild(meta5);

    const link1 = document.createElement('link');
    link1.setAttribute('rel', 'stylesheet');
    link1.setAttribute('type', 'text/css');
    link1.setAttribute('href', 'css/vendor.css');
    document.head.appendChild(link1);

    const link2 = document.createElement('link');
    link2.setAttribute('rel', 'stylesheet');
    link2.setAttribute('href', 'css/bootstrap.min.css');
    document.head.appendChild(link2);

    const link3 = document.createElement('link');
    link3.setAttribute('rel', 'stylesheet');
    link3.setAttribute('type', 'text/css');
    link3.setAttribute('href', 'css/main.css');
    document.head.appendChild(link3);

    const link4 = document.createElement('link');
    link4.setAttribute('rel', 'preconnect');
    link4.setAttribute('href', 'https://fonts.googleapis.com');
    document.head.appendChild(link4);

    const link5 = document.createElement('link');
    link5.setAttribute('rel', 'preconnect');
    link5.setAttribute('href', 'https://fonts.gstatic.com');
    document.head.appendChild(link5);

    const link6 = document.createElement('link');
    link6.setAttribute('rel', 'stylesheet');
    link6.setAttribute('href', 'https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap');
    document.head.appendChild(link6);
  },
  methods:{

  }
}
</script>

<template>
  <div>
<!--    <div id="preloader">-->
<!--      <div id="loader"></div>-->
<!--    </div>-->
   <svg xmlns="http://www.w3.org/2000/svg" style="display: none;">
   	<symbol id="logo-facebook" xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512">
   		<title>Facebook</title><path fill="currentColor" fill-rule="evenodd" d="M480 257.35c0-123.7-100.3-224-224-224s-224 100.3-224 224c0 111.8 81.9 204.47 189 221.29V322.12h-56.89v-64.77H221V208c0-56.13 33.45-87.16 84.61-87.16c24.51 0 50.15 4.38 50.15 4.38v55.13H327.5c-27.81 0-36.51 17.26-36.51 35v42h62.12l-9.92 64.77H291v156.54c107.1-16.81 189-109.48 189-221.31Z"/>
     	</symbol>
     	<symbol id="logo-twitter" xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512">
   		<title>Twitter</title><path fill="currentColor" d="M496 109.5a201.8 201.8 0 0 1-56.55 15.3a97.51 97.51 0 0 0 43.33-53.6a197.74 197.74 0 0 1-62.56 23.5A99.14 99.14 0 0 0 348.31 64c-54.42 0-98.46 43.4-98.46 96.9a93.21 93.21 0 0 0 2.54 22.1a280.7 280.7 0 0 1-203-101.3A95.69 95.69 0 0 0 36 130.4c0 33.6 17.53 63.3 44 80.7A97.5 97.5 0 0 1 35.22 199v1.2c0 47 34 86.1 79 95a100.76 100.76 0 0 1-25.94 3.4a94.38 94.38 0 0 1-18.51-1.8c12.51 38.5 48.92 66.5 92.05 67.3A199.59 199.59 0 0 1 39.5 405.6a203 203 0 0 1-23.5-1.4A278.68 278.68 0 0 0 166.74 448c181.36 0 280.44-147.7 280.44-275.8c0-4.2-.11-8.4-.31-12.5A198.48 198.48 0 0 0 496 109.5Z"/>
     	</symbol>
     	<symbol id="logo-pinterest" xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512">
   		<title>Pinterest</title><path fill="currentColor" d="M256.05 32c-123.7 0-224 100.3-224 224c0 91.7 55.2 170.5 134.1 205.2c-.6-15.6-.1-34.4 3.9-51.4c4.3-18.2 28.8-122.1 28.8-122.1s-7.2-14.3-7.2-35.4c0-33.2 19.2-58 43.2-58c20.4 0 30.2 15.3 30.2 33.6c0 20.5-13.1 51.1-19.8 79.5c-5.6 23.8 11.9 43.1 35.4 43.1c42.4 0 71-54.5 71-119.1c0-49.1-33.1-85.8-93.2-85.8c-67.9 0-110.3 50.7-110.3 107.3c0 19.5 5.8 33.3 14.8 43.9c4.1 4.9 4.7 6.9 3.2 12.5c-1.1 4.1-3.5 14-4.6 18c-1.5 5.7-6.1 7.7-11.2 5.6c-31.3-12.8-45.9-47-45.9-85.6c0-63.6 53.7-139.9 160.1-139.9c85.5 0 141.8 61.9 141.8 128.3c0 87.9-48.9 153.5-120.9 153.5c-24.2 0-46.9-13.1-54.7-27.9c0 0-13 51.6-15.8 61.6c-4.7 17.3-14 34.5-22.5 48a225.13 225.13 0 0 0 63.5 9.2c123.7 0 224-100.3 224-224S379.75 32 256.05 32Z"/>
     	</symbol>
     	<symbol id="logo-instagram" xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512">
   		<title>Instagram</title><path fill="currentColor" d="M349.33 69.33a93.62 93.62 0 0 1 93.34 93.34v186.66a93.62 93.62 0 0 1-93.34 93.34H162.67a93.62 93.62 0 0 1-93.34-93.34V162.67a93.62 93.62 0 0 1 93.34-93.34h186.66m0-37.33H162.67C90.8 32 32 90.8 32 162.67v186.66C32 421.2 90.8 480 162.67 480h186.66C421.2 480 480 421.2 480 349.33V162.67C480 90.8 421.2 32 349.33 32Z"/><path fill="currentColor" d="M377.33 162.67a28 28 0 1 1 28-28a27.94 27.94 0 0 1-28 28ZM256 181.33A74.67 74.67 0 1 1 181.33 256A74.75 74.75 0 0 1 256 181.33m0-37.33a112 112 0 1 0 112 112a112 112 0 0 0-112-112Z"/>
     	</symbol>
     	<symbol id="logo-youtube" xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512">
   		<title>Youtube</title><path fill="currentColor" d="M508.64 148.79c0-45-33.1-81.2-74-81.2C379.24 65 322.74 64 265 64h-18c-57.6 0-114.2 1-169.6 3.6C36.6 67.6 3.5 104 3.5 149C1 184.59-.06 220.19 0 255.79q-.15 53.4 3.4 106.9c0 45 33.1 81.5 73.9 81.5c58.2 2.7 117.9 3.9 178.6 3.8q91.2.3 178.6-3.8c40.9 0 74-36.5 74-81.5c2.4-35.7 3.5-71.3 3.4-107q.34-53.4-3.26-106.9ZM207 353.89v-196.5l145 98.2Z"/>
     	</symbol>
     	<symbol id="person" xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512">
   		<title>Login</title><path fill="currentColor" d="M332.64 64.58C313.18 43.57 286 32 256 32c-30.16 0-57.43 11.5-76.8 32.38c-19.58 21.11-29.12 49.8-26.88 80.78C156.76 206.28 203.27 256 256 256s99.16-49.71 103.67-110.82c2.27-30.7-7.33-59.33-27.03-80.6ZM432 480H80a31 31 0 0 1-24.2-11.13c-6.5-7.77-9.12-18.38-7.18-29.11C57.06 392.94 83.4 353.61 124.8 326c36.78-24.51 83.37-38 131.2-38s94.42 13.5 131.2 38c41.4 27.6 67.74 66.93 76.18 113.75c1.94 10.73-.68 21.34-7.18 29.11A31 31 0 0 1 432 480Z"/>
     	</symbol>
     	<symbol id="search" xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512">
   		<title>Search</title><path fill="currentColor" d="M456.69 421.39L362.6 327.3a173.81 173.81 0 0 0 34.84-104.58C397.44 126.38 319.06 48 222.72 48S48 126.38 48 222.72s78.38 174.72 174.72 174.72A173.81 173.81 0 0 0 327.3 362.6l94.09 94.09a25 25 0 0 0 35.3-35.3ZM97.92 222.72a124.8 124.8 0 1 1 124.8 124.8a124.95 124.95 0 0 1-124.8-124.8Z"/>
     	</symbol>
     	<symbol id="cart" xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512">
   		<title>Cart</title><circle cx="176" cy="416" r="32" fill="currentColor"/><circle cx="400" cy="416" r="32" fill="currentColor"/><path fill="currentColor" d="M456.8 120.78a23.92 23.92 0 0 0-18.56-8.78H133.89l-6.13-34.78A16 16 0 0 0 112 64H48a16 16 0 0 0 0 32h50.58l45.66 258.78A16 16 0 0 0 160 368h256a16 16 0 0 0 0-32H173.42l-5.64-32h241.66A24.07 24.07 0 0 0 433 284.71l28.8-144a24 24 0 0 0-5-19.93Z"/>
     	</symbol>
     	<symbol id="long-arrow-alt-left" xmlns="http://www.w3.org/2000/svg" class="la" viewBox="0 0 32 32">
           <title>Long Arrow Left</title><path fill="currentColor" d="M10.813 9.281L4.093 16l6.72 6.719l1.406-1.438L7.938 17H28v-2H7.937l4.282-4.281z"/>
       </symbol>
       <symbol id="long-arrow-alt-right" xmlns="http://www.w3.org/2000/svg" class="la" viewBox="0 0 32 32">
       	<title>Long Arrow Right</title><path fill="currentColor" d="M21.188 9.281L19.78 10.72L24.063 15H4v2h20.063l-4.282 4.281l1.407 1.438L27.905 16z"/>
       </symbol>
     	<symbol id="caret-down" xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512">
   		<title>Caret Down</title><path fill="currentColor" d="m98 190.06l139.78 163.12a24 24 0 0 0 36.44 0L414 190.06c13.34-15.57 2.28-39.62-18.22-39.62h-279.6c-20.5 0-31.56 24.05-18.18 39.62Z"/>
     	</symbol>
     	<symbol id="arrow-back" xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512">
   		<title>Arrow Back</title><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="48" d="M244 400L100 256l144-144M120 256h292"/>
     	</symbol>
     	<symbol id="arrow-forward" xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512">
   		<title>Arrow Forward</title><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="48" d="m268 112l144 144l-144 144m124-144H100"/>
     	</symbol>
     	<symbol id="chevron-forward" xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512">
   		<title>Chevron Forward</title><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="48" d="m184 112l144 144l-144 144"/>
     	</symbol>
     	<symbol id="play" xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512">
   		<title>Play</title><path fill="currentColor" d="M133 440a35.37 35.37 0 0 1-17.5-4.67c-12-6.8-19.46-20-19.46-34.33V111c0-14.37 7.46-27.53 19.46-34.33a35.13 35.13 0 0 1 35.77.45l247.85 148.36a36 36 0 0 1 0 61l-247.89 148.4A35.5 35.5 0 0 1 133 440Z"/>
     	</symbol>
     	<symbol id="menu-sharp" xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512">
   		<title>Menu</title><path fill="currentColor" d="M64 384h384v-42.67H64Zm0-106.67h384v-42.66H64ZM64 128v42.67h384V128Z"/>
     	</symbol>
     	<symbol id="close-sharp" xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512">
   		<title>Cross</title><path fill="currentColor" d="M400 145.49L366.51 112L256 222.51L145.49 112L112 145.49L222.51 256L112 366.51L145.49 400L256 289.49L366.51 400L400 366.51L289.49 256L400 145.49z"/>
     	</symbol>
   </svg>



   <section id="latest-posts" class="latest-posts margin-large">
   	<div class="container">
   		<div class="row">
   			<div class="post-item col-md-4">
   				<figure class="zoom-effect">
   					<a href="single-post.html" class="zoom-in"><img src="./images/item1.jpg" alt="stories" class="blogImg img-fluid"></a>
   				</figure>
   				<div class="story-title-wrap mt-3">
   					<div class="post-meta"><a href="blog.html">Fashion</a></div>
   					<h3 class="story-title"><a href="single-post.html">10 Distinctive Features of the iPhone and iPod Touch</a></h3>
   					<div class="entry-meta">
   						<span class="author"><span class="sp">by</span><span class="author-name">Jenny Matt</span></span>
   						<span class="meta-date"><span class="sp">-</span><time class="published" datetime="">Feb 12, 2022</time></span>
   					</div>
   				</div>
   			</div>
   			<div class="videos-carousel col-md-4">
   				<div class="post-item">
   					<figure class="zoom-effect">
   						<a  type="button" class="video-btn zoom-in" data-bs-toggle="modal" data-src="https://www.youtube.com/embed/W_tIumKa8VY" data-bs-target="#myModal">
   							<img src="./images/videoitem1.jpg" alt="stories" class="blogImg img-fluid">
   							<svg class="bi" width="34" height="34"><use xlink:href="#play"></use></svg>
   						</a>
   					</figure>
   					<div class="story-title-wrap mt-3">
   						<div class="post-meta"><a href="blog.html">Videos</a></div>
   						<h3 class="story-title"><a href="single-post.html">Take Your Jeans From Sunday Brunch To A Monday Work Meeting</a></h3>
   						<div class="entry-meta">
   							<span class="author"><span class="sp">by</span><span class="author-name">Jenny Matt</span></span>
   							<span class="meta-date"><span class="sp">-</span><time class="published" datetime="">Feb 12, 2022</time></span>
   						</div>
   					</div>
   				</div>
   			</div>
   			<div class="post-item col-md-4">
   				<figure class="zoom-effect">
   					<a href="single-post.html" class="zoom-in"><img src="./images/item2.jpg" alt="stories" class="blogImg img-fluid"></a>
   				</figure>
   				<div class="story-title-wrap mt-3">
   					<div class="post-meta"><a href="blog.html">Fashion</a></div>
   					<h3 class="story-title"><a href="single-post.html">10 Things That Make the iPhone and iPod touch different</a></h3>
   					<div class="entry-meta">
   						<span class="author"><span class="sp">by</span><span class="author-name">Jenny Matt</span></span>
   						<span class="meta-date"><span class="sp">-</span><time class="published" datetime="">Feb 12, 2022</time></span>
   					</div>
   				</div>
   			</div>
   			<div class="post-item col-md-4">
   				<figure class="zoom-effect">
   					<a href="single-post.html" class="zoom-in"><img src="./images/item3.jpg" alt="stories" class="blogImg img-fluid"></a>
   				</figure>
   				<div class="story-title-wrap mt-3">
   					<div class="post-meta"><a href="blog.html">Fashion</a></div>
   					<h3 class="story-title"><a href="single-post.html">10 Things That Make the iPhone and iPod touch different</a></h3>
   					<div class="entry-meta">
   						<span class="author"><span class="sp">by</span><span class="author-name">Jenny Matt</span></span>
   						<span class="meta-date"><span class="sp">-</span><time class="published" datetime="">Feb 12, 2022</time></span>
   					</div>
   				</div>
   			</div>
   			<div class="post-item col-md-4">
   				<figure class="zoom-effect">
   					<a href="single-post.html" class="zoom-in"><img src="./images/item4.jpg" alt="stories" class="blogImg img-fluid"></a>
   				</figure>
   				<div class="story-title-wrap mt-3">
   					<div class="post-meta"><a href="blog.html">Fashion</a></div>
   					<h3 class="story-title"><a href="single-post.html">10 Distinctive Features of the iPhone and iPod Touch</a></h3>
   					<div class="entry-meta">
   						<span class="author"><span class="sp">by</span><span class="author-name">Jenny Matt</span></span>
   						<span class="meta-date"><span class="sp">-</span><time class="published" datetime="">Feb 12, 2022</time></span>
   					</div>
   				</div>
   			</div>
   			<div class="videos-carousel col-md-4">
   				<div class="post-item">
   					<figure class="zoom-effect">
   						<a  type="button" class="video-btn zoom-in" data-bs-toggle="modal" data-src="https://www.youtube.com/embed/W_tIumKa8VY" data-bs-target="#myModal">
   							<img src="./images/videoitem3.jpg" alt="stories" class="blogImg img-fluid">
   							<svg class="bi" width="34" height="34"><use xlink:href="#play"></use></svg>
   						</a>
   					</figure>
   					<div class="story-title-wrap mt-3">
   						<div class="post-meta"><a href="blog.html">Videos</a></div>
   						<h3 class="story-title"><a href="single-post.html">Take Your Jeans From Sunday Brunch To A Monday Work Meeting</a></h3>
   						<div class="entry-meta">
   							<span class="author"><span class="sp">by</span><span class="author-name">Jenny Matt</span></span>
   							<span class="meta-date"><span class="sp">-</span><time class="published" datetime="">Feb 12, 2022</time></span>
   						</div>
   					</div>
   				</div>
   			</div>
   			<div class="post-item col-md-4">
   				<figure class="zoom-effect">
   					<a href="single-post.html" class="zoom-in"><img src="./images/item5.jpg" alt="stories" class="blogImg img-fluid"></a>
   				</figure>
   				<div class="story-title-wrap mt-3">
   					<div class="post-meta"><a href="blog.html">Fashion</a></div>
   					<h3 class="story-title"><a href="single-post.html">10 Things That Make the iPhone and iPod touch different</a></h3>
   					<div class="entry-meta">
   						<span class="author"><span class="sp">by</span><span class="author-name">Jenny Matt</span></span>
   						<span class="meta-date"><span class="sp">-</span><time class="published" datetime="">Feb 12, 2022</time></span>
   					</div>
   				</div>
   			</div>
   			<div class="videos-carousel col-md-4">
   				<div class="post-item">
   					<figure class="zoom-effect">
   						<a  type="button" class="video-btn zoom-in" data-bs-toggle="modal" data-src="https://www.youtube.com/embed/W_tIumKa8VY" data-bs-target="#myModal">
   							<img src="./images/videoitem2.jpg" alt="stories" class="blogImg img-fluid">
   							<svg class="bi" width="34" height="34"><use xlink:href="#play"></use></svg>
   						</a>
   					</figure>
   					<div class="story-title-wrap mt-3">
   						<div class="post-meta"><a href="blog.html">Videos</a></div>
   						<h3 class="story-title"><a href="single-post.html">Take Your Jeans From Sunday Brunch To A Monday Work Meeting</a></h3>
   						<div class="entry-meta">
   							<span class="author"><span class="sp">by</span><span class="author-name">Jenny Matt</span></span>
   							<span class="meta-date"><span class="sp">-</span><time class="published" datetime="">Feb 12, 2022</time></span>
   						</div>
   					</div>
   				</div>
   			</div>
   			<div class="post-item col-md-4">
   				<figure class="zoom-effect">
   					<a href="single-post.html" class="zoom-in"><img src="./images/item6.jpg" alt="stories" class="blogImg img-fluid"></a>
   				</figure>
   				<div class="story-title-wrap mt-3">
   					<div class="post-meta"><a href="blog.html">Fashion</a></div>
   					<h3 class="story-title"><a href="single-post.html">10 Things That Make the iPhone and iPod touch different</a></h3>
   					<div class="entry-meta">
   						<span class="author"><span class="sp">by</span><span class="author-name">Jenny Matt</span></span>
   						<span class="meta-date"><span class="sp">-</span><time class="published" datetime="">Feb 12, 2022</time></span>
   					</div>
   				</div>
   			</div>

   		</div>

           <nav class="navigation paging-navigation text-center padding-medium" role="navigation">
             <div class="pagination loop-pagination d-flex justify-content-center align-items-center">
               <a href="#" class="pe-3">
                 <svg class="bi" width="30" height="30"><use xlink:href="#long-arrow-alt-left"></use></svg>
               </a>
               <span aria-current="page" class="page-numbers current pe-3">1</span>
               <a class="page-numbers pe-3" href="#">2</a>
               <a class="page-numbers pe-3" href="#">3</a>
               <a class="page-numbers pe-3" href="#">4</a>
               <a class="page-numbers" href="#">5</a>
               <a href="#" class="ps-3">
                 <svg class="bi" width="30" height="30"><use xlink:href="#long-arrow-alt-right"></use></svg>
               </a>
             </div>
           </nav>
   	</div>
   </section>



  </div>

</template>

<style scoped>
@import 'css/main.css';
 @import 'css/normalize.css';
 /* @import 'css/vendor.css'; */
 @import 'css/bootstrap.min.css';
</style>



// WEBPACK FOOTER //
// src/view/blog.vue